// @ts-nocheck
import { addressDrawerPunchOutCustomerStyles } from "@insite/content-library/Widgets/Header/AddressDrawerPunchOutCustomer";
import { addressProps } from "@store/Themes/common/props/address";

type Styles = typeof addressDrawerPunchOutCustomerStyles;

Object.assign<Styles>(addressDrawerPunchOutCustomerStyles, {
    customerHeadingText: addressProps.label,
    shipToHeadingText: addressProps.label,
    addressInfoDisplay: {
        wrapper: addressProps.wrapperSmall,
    },
});
